import { actionCopyEs } from "./actionCopy";

export const formPageCopyEs = {
    entryFor: (label) => `Registro para ${label}`,
    next: actionCopyEs.next,
    back: actionCopyEs.back,
    changingAnswers: "Está cambiando respuestas que ya dio",
    submit: actionCopyEs.submit,
    startNow: "Comenzar ahora",
    startForm: "Comenzar el formulario",
    startingForm: "Iniciando el formulario...",
    formSubmitted: "Formulario enviado",
    errorsOnPage: (count) =>
        count === 1 ? "Error en 1 pregunta de esta página" : `Errores en ${count} preguntas de esta página`,
    invalidValue: "Valor no válido",
    groupTotal: (total, target) => `Total: ${total} de ${target}`,
    groupMustTotal: (target) => `Estas respuestas deben sumar ${target}`,
    groupPlaced: (total, target) => `${total} de ${target} asignados`,
    groupLeft: (n) => `faltan ${n}`,
    groupOver: (n) => `${n} de más`,
    groupComplete: (target) => `Los ${target} asignados`,
    countIncrease: (label) => `Sumar uno a ${label}`,
    countDecrease: (label) => `Restar uno a ${label}`,
    countRequired: "Introduzca un número, o 0 si ninguno",
    answerTooHigh: "Este número no puede ser mayor que su respuesta anterior",
    exclusiveConflict: "Esta respuesta no se puede combinar con las demás respuestas",
    tickAtLeastOne: "Seleccione al menos una respuesta",
    pageOf: (page, total) => `Página ${page} de ${total}`,
    carriedNote: "Hemos trasladado esto de la última vez.",
    yes: "Sí",
    no: "No",
    ownOptionOther: "Otro",
    ownOptionPlaceholder: "Escriba su respuesta",
    ownOptionAdd: "Añadir",
    ownOptionSave: "Guardar",
    ownOptionCancel: "Cancelar",
    ownOptionEdit: (label) => `Editar "${label}"`,
    ownOptionDelete: (label) => `Eliminar «${label}»`,
    ownOptionInUse: "Ya ha usado esta respuesta, así que no se puede eliminar. Puede cambiarle el nombre.",
    ownOptionEmpty: "Escriba su respuesta",
    ownOptionTooLong: "Utilice 100 caracteres como máximo",
    ownOptionLimit: "Puede añadir hasta 20 respuestas propias",
    ownOptionFailed: "No hemos podido guardarlo. Inténtelo de nuevo.",
    questionOf: (current, total) => `Pregunta ${current} de ${total}`,
    questionsRange: (min, max) => `Preguntas de ${min} a ${max}`,
    questionsRangeOf: (min, max, total) => `Preguntas de ${min} a ${max} de ${total}`,
    formatProgressLabel: ({ min, max, total, pageNumber, pageTotal }) => {
        let questionPart: string;
        if (min === max) {
            questionPart = `Pregunta ${min} de ${total}`;
        } else if (max === total) {
            questionPart = `Preguntas de ${min} a ${max}`;
        } else {
            questionPart = `Preguntas de ${min} a ${max} de ${total}`;
        }

        if (min === max && min === pageNumber && pageTotal === total) {
            return questionPart;
        }

        return `Página ${pageNumber} de ${pageTotal} - ${questionPart}`;
    },
};
